import React from 'react';
import { CreditCard } from 'lucide-react';

const BillingSettings: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-4">
        <div className="rounded-2xl bg-gradient-to-br from-yellow-500 to-orange-600 p-3">
          <CreditCard className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Billing & Subscription</h1>
          <p className="text-gray-600">Manage your subscription and payment methods</p>
        </div>
      </div>
      <div className="rounded-2xl border border-gray-200 bg-gray-50 p-8 text-center">
        <p className="text-gray-600">Billing settings content will be implemented here.</p>
      </div>
    </div>
  );
};

export default BillingSettings;
